import {connect} from "react-redux";
import GameMenu from "./GamesMenu.jsx";

const mapStateToProps = (state) => {
    return {
        menu: state.gamesMenu.current,
        updated: state.games.updated,
    };
};

const GameMenuContainer = connect(
    mapStateToProps
)(GameMenu);

export default GameMenuContainer